
{
  "familyId": "SWW-LEEN-ENG-KOF",
  "questions": [
    {
      "id": "SWW-LEEN-ENG-KOF-001",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "multiple_choice",
      "question": "Een klasgenoot schrijft 'Ik raasde gisteren over het circuit.' Welke vorm hoort er bij 'racen' en welke drie regels moet je tegelijk afwegen om dat te kiezen?",
      "context": null,
      "options": ["racete", "racede", "racte", "raasde"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "racen", "stem": "race", "lastLetter": "e", "useTE": true, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "Bij Engelse leenwoorden pas je 't kofschip toe op de KLANK. Zeg 'race' hardop: je hoort /s/ aan het eind. De s zit in 't kofschip → -te.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_race",
      "variantIndex": 1,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Regel: kofschip bij Engelse leenwoorden — kijk naar de KLANK, niet de letter. Stap 1: De stam van 'racen' is 'race' (Engelse spelling behouden). Stap 2: Zeg 'race' hardop: je hoort /s/ aan het eind, niet /e/. Stap 3: De /s/ zit WEL in 't kofschip → dus -te. Stap 4: race + te = racete. Checkstrategie: (a) spreek de stam hardop uit, (b) luister naar de laatste klank, (c) controleer of die klank in 't kofschip zit — dan -te, anders -de. Drie regels die hier samenkomen: Engelse spelling behouden, kofschip op klank, plak uitgang aan stam.",
        "solutionSteps": ["Bepaal de stam: racen → race (Engelse spelling intact)", "Luister naar de KLANK: je hoort /s/ aan het eind van 'race'", "/s/ zit in 't kofschip → -te (niet -de)", "race + te = racete", "Check: vergelijk met racede, racte, raasde — welke past alle drie regels?"],
        "distractorExplanations": {
          "0": "Correct! Drie regels samen: Engelse spelling behouden (race blijft race), kofschip op klank (/s/ in kofschip → -te), uitgang aan stam (race + te = racete).",
          "1": "Hier is naar de letter gekeken in plaats van de klank. 'Racede' gebruikt -de, maar de regel kofschip-op-klank zegt: je hoort /s/ aan het eind van 'race' (s zit in kofschip). Dus -te: racete.",
          "2": "De Engelse spelling is hier aangepast. 'Racte' mist de -e van 'race'. De regel Engelse-spelling-behouden zegt: race blijft race. Dus: race + te = racete.",
          "3": "De spelling is hier 'vernederlandst'. 'Raasde' verandert de spelling van 'race' naar 'raas'. De regel Engelse-spelling-behouden zegt: de stam blijft race, niet raas. Dus: racete."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-letter-not-sound", "label": "Naar letter gekeken i.p.v. klank", "optionIndex": 1 },
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse -e weggelaten uit stam", "optionIndex": 2 },
          { "id": "sww.loanword-spelling-dutchified", "label": "Engelse spelling vernederlandst", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-002",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "multiple_choice",
      "question": "Vergelijk vier vormen van 'uploaden' in de zin 'Gisteren ... ik het bestand naar de cloud.' Welke vorm combineert correct: Engelse stam-spelling, kofschip-regel én verleden-tijd-context?",
      "context": null,
      "options": ["uploadde", "uploadte", "uploade", "upgeload"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "uploaden", "stem": "upload", "lastLetter": "d", "useTE": false, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "De stam 'upload' eindigt op 'd'. Deze letter staat NIET in 't kofschip, dus: upload + de = uploadde.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_upload",
      "variantIndex": 2,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Regel: kofschip bij Engelse leenwoorden + analyse van zinscontext. Stap 1: 'Gisteren' is signaalwoord voor verleden tijd. Stap 2: De stam van 'uploaden' is 'upload'. Stap 3: De laatste letter is 'd', die NIET in 't kofschip staat → -de. Stap 4: upload + de = uploadde (dubbele d). Checkstrategie: (a) check signaalwoord voor tijd, (b) bepaal stam, (c) kofschip-check op laatste letter, (d) vergelijk je vorm met de drie alternatieven en sluit elk gemotiveerd uit.",
        "solutionSteps": ["Analyseer context: 'Gisteren' → verleden tijd", "Bepaal de stam: uploaden → upload", "Kofschip-check: 'd' staat NIET in 't kofschip → -de", "upload + de = uploadde (dubbele d ontstaat)", "Check: sluit uploadte, uploade en upgeload gemotiveerd uit"],
        "distractorExplanations": {
          "0": "Correct! Drie controles slagen: 'gisteren' → verleden tijd; stam = upload; 'd' niet in kofschip → -de. Upload + de = uploadde.",
          "1": "Hier is -te gebruikt bij een stam die op d eindigt. 'Uploadte' faalt op de kofschip-controle: 'd' staat NIET in 't kofschip. Correct: uploadde.",
          "2": "De verleden tijd is hier verkeerd gevormd. 'Uploade' mist de d van de stam. De stam-controle zegt: 'upload' (met d). Dus: uploadde.",
          "3": "Hier is het voltooid deelwoord gebruikt zonder hulpwerkwoord. De zin-controle ('Gisteren ... ik') vraagt om verleden tijd, niet om VD: uploadde."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip-uitgang verkeerd gekozen (-te i.p.v. -de)", "optionIndex": 1 },
          { "id": "sww.stem-d-lost", "label": "Stam-d weggelaten in uitgang", "optionIndex": 2 },
          { "id": "sww.vd-without-aux", "label": "Voltooid deelwoord gebruikt zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-003",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "multiple_choice",
      "question": "Beoordeel de vier zinnen met 'downloaden + gisteren + meervoud onderwerp'. Welke zin past alle drie de regels (tijd, persoon, kofschip)?",
      "context": null,
      "options": ["We downloadden de app gisteren.", "We downloadten de app gisteren.", "We downloaden de app gisteren.", "We gedownload de app gisteren."],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "downloaden", "stem": "download", "lastLetter": "d", "useTE": false, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "De stam 'download' eindigt op 'd' (niet in kofschip), dus meervoud verleden tijd: download + den = downloadden.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_download",
      "variantIndex": 3,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "Regel: drie afwegingen tegelijk — tijd, persoon, kofschip. Stap 1 (tijd): 'gisteren' → verleden tijd. Stap 2 (persoon): 'We' → meervoud → uitgang -en. Stap 3 (kofschip): stam 'download' eindigt op 'd' (niet in kofschip) → -de(n). Stap 4: download + den = downloadden. Checkstrategie: doorloop expliciet de drie regels en sluit elk alternatief gemotiveerd uit — welke regel schendt het?",
        "solutionSteps": ["Tijd-check: 'gisteren' → verleden tijd", "Persoon-check: 'We' → meervoud → -en", "Kofschip-check: 'd' niet in kofschip → -de(n)", "Combineer: download + den = downloadden", "Sluit downloadten (kofschip-fout), downloaden (tijd-fout) en gedownload (geen hulpww) uit"],
        "distractorExplanations": {
          "0": "Correct! Alle drie regels kloppen: verleden tijd (gisteren), meervoud (We → -en), kofschip ('d' niet in kofschip → -de). Resultaat: downloadden.",
          "1": "Hier is -ten gebruikt bij een stam die op d eindigt. De kofschip-regel faalt: 'd' staat NIET in 't kofschip. Correct: downloadden.",
          "2": "Hier is de tegenwoordige tijd gebruikt in een verleden-tijdcontext. De tijd-regel faalt: 'gisteren' vraagt om verleden tijd. Correct: downloadden.",
          "3": "Hier is het voltooid deelwoord gebruikt zonder hulpwerkwoord. De zinsbouw-regel faalt: 'gedownload' hoort bij 'hebben'. Hier is verleden tijd nodig: downloadden."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip-uitgang verwisseld (-ten i.p.v. -den)", "optionIndex": 1 },
          { "id": "sww.tense-signal-ignored", "label": "Signaalwoord 'gisteren' genegeerd, TT gebruikt", "optionIndex": 2 },
          { "id": "sww.vd-without-aux", "label": "Voltooid deelwoord gebruikt zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-004",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "multiple_choice",
      "question": "Vergelijk de vier vormen van 'checken' in 'De leraar ... de antwoorden na de toets.' Welke vorm past tegelijk: NL-verleden-tijd-uitgang, kofschip-regel, en Engelse stam-spelling?",
      "context": null,
      "options": ["checkte", "checkde", "gechecked", "gechekt"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "checken", "stem": "check", "lastLetter": "k", "useTE": true, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "De stam 'check' eindigt op 'k'. De k-klank zit WEL in 't kofschip → -te. check + te = checkte.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_check",
      "variantIndex": 4,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Regel: drie regels combineren — NL-verleden-tijd, kofschip-op-klank, Engelse stam behouden. Stap 1: stam van 'checken' = 'check' (Engelse spelling intact). Stap 2: laatste klank /k/ zit WEL in 't kofschip → -te. Stap 3: check + te = checkte. Checkstrategie: (a) Engelse stam-check (blijft 'check', niet 'chek'), (b) kofschip-check op klank, (c) NL-uitgang (geen Engelse -ed). Sluit elke distractor uit door te benoemen welke regel schendt.",
        "solutionSteps": ["Bepaal de stam: checken → check (Engelse spelling)", "Kofschip-check: 'k' zit in 't kofschip → -te", "check + te = checkte", "Sluit checkde (kofschip-fout), gechecked (Engelse grammatica) en gechekt (stam-fout) gemotiveerd uit"],
        "distractorExplanations": {
          "0": "Correct! Drie regels gelijktijdig: Engelse stam 'check' intact, /k/ in kofschip → -te, NL-uitgang gebruikt. Resultaat: checkte.",
          "1": "Hier is -de gebruikt bij een stam die op k eindigt. De kofschip-regel faalt: 'k' zit WEL in 't kofschip. Correct: checkte.",
          "2": "Hier is de Engelse verleden tijd (-ed) gebruikt. De NL-uitgang-regel faalt: in het Nederlands plak je -te of -de, geen -ed. Correct: checkte.",
          "3": "Hier is het voltooid deelwoord met aangepaste spelling. Twee regels falen: VD i.p.v. VT, én 'chekt' i.p.v. 'checkt' (Engelse stam-spelling). Correct: checkte."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip verkeerd toegepast (-de i.p.v. -te)", "optionIndex": 1 },
          { "id": "sww.loanword-english-grammar", "label": "Engelse -ed gebruikt i.p.v. Nederlandse uitgang", "optionIndex": 2 },
          { "id": "sww.past-participle-wrong-form", "label": "Voltooid deelwoord i.p.v. verleden tijd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-005",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "fill_in",
      "question": "Vorm de verleden tijd van 'surfen' voor de ik-persoon. Combineer Engelse stam-spelling met de kofschip-regel op klank. Typ het hele woord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["surfte"], "caseSensitive": false, "placeholder": "..." },
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "surfen", "stem": "surf", "lastLetter": "f", "useTE": true, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "De stam 'surf' eindigt op 'f'. De f-klank zit WEL in 't kofschip → -te. surf + te = surfte.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_kofschip_surf_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Regel: stam + kofschip + Engelse spelling tegelijk toepassen. Stap 1: stam van 'surfen' = 'surf' (Engels). Stap 2: laatste klank /f/ zit WEL in 't kofschip → -te. Stap 3: surf + te = surfte. Checkstrategie: zeg 't kofschip op ('t-kofschip), controleer of de eindklank van de stam erin zit, en zo ja → -te. Vergelijk je antwoord met mogelijke fouten: 'surfde' (kofschip-fout), 'surfed' (Engelse grammatica), 'gesurft' (VD i.p.v. VT).",
        "solutionSteps": ["Bepaal de stam: surfen → surf (Engelse spelling)", "Kofschip-check op klank: /f/ in kofschip → -te", "surf + te = surfte", "Check: vergelijk met surfde (fout: f wél in kofschip) en surfed (Engelse -ed)"]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Mogelijke fout: 'surfde' (f vergeten in kofschip)" },
          { "id": "sww.loanword-english-grammar", "label": "Mogelijke fout: 'surfed' (Engelse -ed gebruikt)" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-006",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "error_spotting",
      "question": "Vind de werkwoordspellingfouten in deze tekst met Engelse leenwoorden.",
      "context": null,
      "correctAnswer": 0,
      "data": {
        "text": "Wij checkden de score na de wedstrijd. Hij downloadte het bestand snel naar zijn laptop.",
        "errors": [
          { "word": "checkden", "position": 1, "correction": "checkten", "explanation": "Stam 'check' eindigt op k. K zit in kofschip, dus uitgang -ten (meervoud): checkten." },
          { "word": "downloadte", "position": 8, "correction": "downloadde", "explanation": "Stam 'download' eindigt op d. D zit NIET in kofschip, dus uitgang -de: downloadde (dubbel d)." }
        ]
      },
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "checken/downloaden", "stem": "check/download", "lastLetter": "k/d", "useTE": true, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kofschip bij Engelse leenwoorden", "content": "Bepaal de stam (werkwoord min -en, Engelse spelling behouden). Laatste stamletter in kofschip (k, f, s, ch, p, t): -te(n). Andere letter: -de(n).", "icon": "lightbulb" } }
      ],
      "conceptId": "english_loanword_kofschip_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Twee fouten met kofschip bij Engelse leenwoorden, beide via dezelfde analyse: bepaal stam → kofschip-check → vergelijk met geschreven vorm. 'Checkden' moet 'checkten' zijn (k in kofschip, dus -ten). 'Downloadte' moet 'downloadde' zijn (d niet in kofschip, dus -de met dubbele d). Checkstrategie: doorloop voor elk werkwoord stam-check + kofschip-check, en vergelijk dan met de geschreven vorm.",
        "solutionSteps": [
          "Bepaal de stam (werkwoord min -en, Engelse spelling)",
          "Kofschip-check op laatste stamletter",
          "In kofschip → -te(n); anders → -de(n)",
          "Bij stam op d/t ontstaat dubbele letter",
          "Vergelijk geschreven vorm met regelvorm en spot de fout"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip-uitgang verwisseld (-den/-ten verwarring)" },
          { "id": "sww.loanword-english-grammar", "label": "Engelse grammatica toegepast op Nederlandse leenwoorden" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-007",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "matching",
      "question": "Koppel elk Engels leenwerkwoord aan de juiste verleden-tijdvorm.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "checken", "right": "checkte" },
          { "left": "downloaden", "right": "downloadde" },
          { "left": "surfen", "right": "surfte" },
          { "left": "scoren", "right": "scoorde" },
          { "left": "mixen", "right": "mixte" }
        ]
      },
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "diverse", "stem": "diverse", "lastLetter": "diverse", "useTE": true, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Strategie",
            "content": "Bepaal de stam, luister naar de eindklank, kofschip-check op klank, plak -te of -de aan de stam. Behoud altijd de Engelse spelling.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "english_loanword_kofschip_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Vijf koppelingen, vijf keer dezelfde analyse: stam-check + kofschip-op-klank + Engelse spelling behouden. checken → check + te (k in kofschip) = checkte; downloaden → download + de (d niet in kofschip) = downloadde; surfen → surf + te (f in kofschip) = surfte; scoren → scoor + de (r niet in kofschip) = scoorde; mixen → mix + te (x = ks, s in kofschip) = mixte. Checkstrategie: voor elk paar bepaal je eerst de eindklank, dan de kofschip-uitgang, en pas dan koppel je. Let op 'mixen': de letter x is dubbele klank /ks/ — de /s/-klank telt.",
        "solutionSteps": [
          "Voor elk werkwoord: bepaal de stam (Engelse spelling intact)",
          "Luister naar de eindklank (let op x = /ks/)",
          "Kofschip-check op klank",
          "Plak uitgang aan en behoud Engelse spelling",
          "Check elke koppeling: klopt stam + uitgang met de getoonde vorm?"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-misapplied", "label": "Kofschip-uitgang verwisseld" },
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse stamspelling aangepast" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-KOF-008",
      "familyId": "SWW-LEEN-ENG-KOF",
      "module": "SpellingWW",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_kofschip",
      "questionType": "categorize",
      "question": "Sorteer elke verleden-tijdvorm op de juiste uitgang.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Uitgang -te (klank in kofschip)", "Uitgang -de (klank niet in kofschip)"],
        "items": [
          { "text": "checkte", "correctCategory": 0 },
          { "text": "surfte", "correctCategory": 0 },
          { "text": "mixte", "correctCategory": 0 },
          { "text": "racete", "correctCategory": 0 },
          { "text": "downloadde", "correctCategory": 1 },
          { "text": "scoorde", "correctCategory": 1 },
          { "text": "gameden", "correctCategory": 1 },
          { "text": "mailde", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [{ "type": "kofschipMnemonic", "data": { "verb": "diverse", "stem": "diverse", "lastLetter": "diverse", "useTE": true, "label": "Engelse Leenwoorden + Kofschip" } }],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kofschip op klank",
            "content": "-te bij: k, f, s, ch, p, t (én s-klank zoals 'race', ks-klank zoals 'mix'). -de bij: alle andere klanken (r, l, m, n, b, d, g, v, z, etc.).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "english_loanword_kofschip_categorize",
      "variantIndex": 8,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Regel: kofschip-classificatie op klank, niet op letter. -te: checkte (k), surfte (f), mixte (ks/s), racete (s-klank van 'race'). -de: downloadde (d), scoorde (r), gameden (m), mailde (l). Bij Engelse leenwoorden tel je de eindklank van de stam, niet de geschreven letter — vooral bij 'race' (eindigt op letter -e, maar klank /s/) en 'mix' (letter x, klank /ks/). Checkstrategie: spreek elke stam hardop uit en classificeer op de gehoorde eindklank.",
        "solutionSteps": [
          "Bepaal voor elke vorm de stam",
          "Spreek de stam hardop uit en luister naar de eindklank",
          "Klank in kofschip (k,f,s,ch,p,t-familie) → -te",
          "Andere klank → -de",
          "Let op: race (klank /s/), mix (klank /ks/) — laat je niet misleiden door de letter"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.kofschip-letter-not-sound", "label": "Op letter geclassificeerd i.p.v. klank" }
        ]
      }
    }
  ]
}
